import { BodyMetricGroup } from "./bodyMetricTypes";

/**
 * Chart.js draws on a canvas, so it needs the group accents as strings. They mirror the
 * `$bodyMetric_*` colors in colors.scss.
 */
export const BODY_METRIC_CHART_COLORS: Record<
  BodyMetricGroup,
  { line: string; fill: string; soft: string }
> = {
  body: { line: "rgba(150, 155, 255, 0.95)", fill: "rgba(124, 131, 255, 0.4)", soft: "rgba(124, 131, 255, 0.3)" },
  composition: { line: "rgba(102, 222, 205, 0.95)", fill: "rgba(77, 208, 190, 0.38)", soft: "rgba(77, 208, 190, 0.28)" },
  girths: { line: "rgba(255, 140, 208, 0.95)", fill: "rgba(255, 119, 198, 0.38)", soft: "rgba(255, 119, 198, 0.28)" },
  heart: { line: "rgba(255, 138, 128, 0.95)", fill: "rgba(255, 112, 100, 0.38)", soft: "rgba(255, 112, 100, 0.28)" },
};

export const TRANSPARENT = "rgba(0, 0, 0, 0)";
